import { Box, Stack } from "@chakra-ui/react"
import { Text } from "@/components"

export const BcDocumentRequirements = () => {
  return (
    <Stack>
      <Text fontSize="sm" mb={2}>
        What we need
      </Text>
      <Text>
        1) <Text as="span" fontWeight="bold">Proof of ownership</Text>:
      </Text>
      <Box pl={4}>
        <Text fontSize="sm">
          - If you have options, please share screenshots or grant documents indicating the{" "}
          <Text as="span" fontWeight="bold">vested amounts, grant dates, and strike prices</Text>
        </Text>
        <Text fontSize="sm">
          - If you have shares, please share a screenshot of your stock certificates
        </Text>
      </Box>

      <Text>
        2) <Text as="span" fontWeight="bold">The current FMV (Fair Market Value), aka 409A share price</Text>:
      </Text>
      <Box pl={4}>
        <Text fontSize="sm">- In Carta, the FMV may be found on either the Portfolio page, or near the bottom Exercise Simulator page</Text>
        <Text fontSize="sm">- In Shareworks, the FMV may be found on the Dashboard</Text>
        <Text fontSize="sm">- Other equity portals will typically display the FMV on a summary page</Text>
        <Text fontSize="sm">- Otherwise, ask your stock plan administrator or CFO for the current 409A value</Text>
      </Box>
    </Stack>
  )
}